export default "__VITE_ASSET__US3iDyBx__"